import { WorkedHoursReportActions } from '../constants';

export interface GetWorkedHoursReportsAction {
    type: typeof WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS;
    payload: any;
}

export function getWorkedHoursReports(params: any): GetWorkedHoursReportsAction {
    return {
        type: WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS,
        payload: params,
    };
}

export interface GetWorkedHoursReportsCsvAction {
    type: typeof WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS_CSV;
    payload: any;
}

export function getWorkedHoursReportsCsv(params: any): GetWorkedHoursReportsCsvAction {
    return {
        type: WorkedHoursReportActions.FETCH_WORKED_HOURS_REPORTS_CSV,
        payload: params,
    };
}

export type Actions = GetWorkedHoursReportsAction | GetWorkedHoursReportsCsvAction;
